import React, { useState } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import TimeAgo from "react-timeago";
import getStoriesByCollection, { dateFormatterWithoutTime } from "../../../utils";
import { TimeStamp } from "../../atoms/time-stamp";
import { ResponsiveImage } from "@quintype/components";
import { LoadMoreButton } from "../../atoms/load-more-button";
import { Headline } from "../../atoms/headline";
import { CardImage } from "../../atoms/card-image";
import NlSenaWrapper from "../../pages/nl-sena-wrapper";
import { CollectionName } from "../../atoms/collection-name";

import "./podcast-collection.m.css";

const PodcastCollectionStory = ({ story }) => {
  const getLabel = get(story, ["metadata", "story-attributes", "storyattribute", 0], "");
  return (
    <div styleName="story-wrapper">
      <div className="story-image">
        <CardImage story={story} />
        {getLabel && <div styleName="ribbon">{getLabel}</div>}
      </div>
      <div styleName="story-content">
        <div styleName="time-stamp">
          <TimeStamp story={story} />
        </div>
        <div styleName="headline">
          <Headline story={story} externalLink={true} />
        </div>
        <TimeAgo styleName="time-ago" date={story["last-published-at"]} formatter={dateFormatterWithoutTime} />
      </div>
    </div>
  );
};

PodcastCollectionStory.propTypes = {
  story: PropTypes.object
};

const PodcastCollectionBase = props => {
  const [currentStories, loadMore] = useState(7);
  const collection = get(props, ["data", "collection"], {});
  const collections = collection  &&  collection.items && collection.items .filter(collection => collection.type === "collection") || [];
  const coverImgUrl = get(collection, ["metadata", "cover-image", "cover-image-s3-key"], "");
  const coverImgMetadata = get(collection, ["metadata", "cover-image", "cover-image-metadata"], {});
  const podcastStory = getStoriesByCollection(collection);
  const campaignId = get(collections, [ 0 , "associated-metadata", "campaign_id"], "");
  if (podcastStory.length < 1) {
    return <div styleName="not-found">Stories not found...</div>;
  }
  
  return (
    <div>
      <div className="full-width-with-padding" styleName="wrapper">
        <div styleName="content">
          <h1 styleName="heading">{collection.name}</h1>
          <div styleName="border"></div>
          {coverImgUrl && (
            <div styleName="image display-mobile">
              <figure styleName="image-wrapper">
                <ResponsiveImage
                  slug={coverImgUrl}
                  metadata={coverImgMetadata}
                  aspectRatio={[268, 268]}
                  defaultWidth={259}
                  widths={[250, 375]}
                  alt={collection.name}
                  className="resp-image"
                />
              </figure>
            </div>
          )}
          <p styleName="description">{collection.summary}</p>
        </div>
        {coverImgUrl && (
          <div styleName="image  display-desktop">
            <figure styleName="image-wrapper">
              <ResponsiveImage
                slug={coverImgUrl}
                metadata={coverImgMetadata}
                aspectRatio={[268, 268]}
                defaultWidth={259}
                widths={[250, 375]}
                alt={collection.name}
                className="resp-image"
              />
            </figure>
          </div>
        )}
      </div>
      <div styleName="story">
        {podcastStory.length > 0 && (
          <div>
            {podcastStory.slice(0, 1).map((story, index) => {
              return (
                <div key={index} styleName="first-story">
                  <PodcastCollectionStory story={story} />
                </div>
              );
            })}
            {podcastStory.length > 1 &&
              podcastStory.slice(1, currentStories).map((story, index) => {
                return (
                  <div key={index} styleName="stories">
                    <PodcastCollectionStory story={story} />
                  </div>
                );
              })}
            {currentStories < podcastStory.length && (
              <div styleName="load-more">
                <LoadMoreButton onClick={() => loadMore(currentStories + 3)} />
              </div>
            )}
          </div>
        )}
        <div styleName="campaign"> 
        <div>
          {campaignId && collections.length > 0 && (
            <CollectionName collection={collections[0]} className="desktop-only" />
          )}
          {campaignId && (
            <div>
              <NlSenaWrapper showSingleCampaign={true} campaignId={campaignId}  redirectUrl={props.currentPath} />
            </div>
          )}
        </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {

  return {
    currentPath: get(state, ["qt", "currentPath"], "/"),
  };
}

export const PodcastCollection = connect(mapStateToProps)(PodcastCollectionBase);